import { render } from "./MyOrderView.vue?vue&type=template&id=2d94ab82&scoped=true"
import script from "./MyOrderView.vue?vue&type=script&lang=js"
export * from "./MyOrderView.vue?vue&type=script&lang=js"

import "./MyOrderView.vue?vue&type=style&index=0&id=2d94ab82&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d94ab82"]])

export default __exports__